<template>
    <div id="app">
      <div id="Return_Bar">
        <i class="el-icon-arrow-left"></i>
        <div @click="isreturn" class="isreturn">返回</div>
   
    </div>
    <div id="text">
        <template>
            <div class="step-list" v-for="(c, key) in sceneList" :key="key" >
              <div class="step-list_top">
                <div class="list_top_left">
                     <div class="circle" :class="c.status=='Finish'?'circle':'othercircle'"></div>
                  {{c.name}}
                  <div :class="c.status == 'Finish'?'isgreen':'isred'">
                    {{
                        c.status == "Finish" ? "已完成" : "未完成"
                      }}
                  </div>
                    
                </div>
                <div class="list_top_right">
                  <!-- <el-button @click="goKnowledge(c)" type="primary" size="small">点击学习</el-button> -->
                  <div class="buttonx" @click="gocurriculum">点击学习</div>
                </div>
              </div>
              <div class="step-list_under">
                场景介绍：{{c.description}}
              </div>
            </div>
  </template>
            
    </div>
    </div>
</template>

<script>
export default {
    name:'Scene',
    data() {
        return{
            sceneList:[],//场景列表
            sceneId:this.$route.query.sceneId,//场景与课程id
            tjkId:this.$route.query.tjkId,//淘金客id
            trainId:this.$route.query.trainId,//场次id
            tabIndex:null//二级tab的index
        }
    },
    created(){
        this.Scene()
    },
    methods:{
       // 返回按钮
    isreturn(){
      this.tabIndex=localStorage.getItem('tabIndex')
      this.$router.push({
        path:'/train/index',
        query:{
            tabIndex:this.tabIndex,
            condition:false//判断是否是基础知识点跳课程
        }
      })
    },
    //前往知识点
    goKnowledge(c){
      console.log(c,'dsad')
         this.$router.push({
                 path: "/vedioDetail",
                 query:{
                 courseId:this.courseId,
                 knowledgeSeq:c.knowledge.knowledgeSeq
                 }

               })
          },
    //前往技能提升课程
    gocurriculum(){
      this.$router.push({path:'/train/SpecialCourses',query:{sceneId:this.sceneId,courseId:this.courseId,trainId:this.trainId,tjkId:this.tjkId,}})
    },
    //三级课程
    Scene(){
        this.$http.post(API_ROOT.college + "/voiceScene/queryWithStatus",{sceneId:this.sceneId}).then(
          (res) => {
            var result = res.data;
            console.log(result,'话')
            if (result.success) {
              this.sceneList = result.data.list;
              this.description = result.data.tip;
              //判断场景完成状态
              
              this.sceneList.forEach((item)=>{if(item.status=="Finish"){
                this.decide++
              }})
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/voiceScene/queryWithStatus）！");
          }
        );
    },
    }
}
</script>
<style scoped>
.isreturn{color:#000;cursor: pointer;}
/deep/.el-icon-arrow-left{color: #000;}
.step-list{margin-bottom: 20px;background:#fff;border-radius:5px ;padding: 19px 20px 20px 60px;position: relative;}
.step-list_top{display: flex;justify-content: space-between;}
.list_top_left{display: flex;}
.list_top_left{font-size: 16px;color: #262626;font-weight: 500;position: relative;left: -20px;font-size: 18px;font-family: Source Han Sans CN;color: #262626;line-height: 24px;}
.isred{color: #E53434; margin-right: 10px;font-weight: 600;font-size: 12px;padding: 0px 3px;border: 1px solid #E53434;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #FBE5E5;height: 18px;line-height: 18px;}
.isgreen{color: #14C034; margin-right: 10px;font-weight: 600;font-size: 12px;padding: 0px 3px;border: 1px solid #39CA54;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #D9F4DE;height: 18px;line-height: 18px;}

.step-list_under{margin-top: 15px;background: #f5f6f7;padding: 19px 360px 20px 19px;font-size: 13px;overflow: hidden;color: #000;}
.circle{width: 20px;height: 20px;background:#497AF2;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:4px;color: #fff;font-weight: normal;line-height: 20px;}
.othercircle{width: 20px;height: 20px;background:#D6D6D6;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:4px;color: #fff;font-weight: normal;line-height: 20px;}
.line{    
    width: 2px;
    height: 256px;
    top:24px;
    bottom: 0;
    left: -11px;
    position: absolute;
    border-color: inherit;
    background-color: #1684fc;
    z-index: 99;}
.otherline{    
    width: 2px;
    height: 156px;
    top:24px;
    bottom: 0;
    left: -11px;
    position: absolute;
    border-color: inherit;
    background-color: #BBBBBB;
    z-index: 99;}
#app {
  height: 100%;
  box-sizing: border-box;
   background: #f6f5f8;
}
#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
  background: #fff;
}
/deep/.el-icon-arrow-left {
  margin-top: 5px;
}
#text {
  background: #f6f5f8;
  width: 100%;
  padding: 20px 20px;
}
#text .right {
  width: 100%;
  margin-left: 10px;
}
.right-top {
  display: flex;
  justify-content: space-between;
}
.twolevel_list {
  padding: 10px 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;
  display: flex;
  margin-bottom: 20px;
}
.twolevel_list .left {
  width: 40px;
}
.twolevel_list .left .circle_state {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  margin-top: 3px;
  margin-left: 10px;
  background: #d5d7d8;
  color: #fff;
  text-align: center;
}
.right_listleft {
  font-size: 17px;
  color: #000;
  font-weight: 600;
}
.right_listleft > .pass {
  margin-left: 10px;
  color: #6cc080;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #6cc080;
  border-radius: 5px;
  background: #d3f6d3;
}
.right_listleft > .failed {
  margin-left: 10px;
  color: #e15062;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #e15062;
  border-radius: 5px;
  background: #ffe3e2;
}
.right_listright {
  background: #1684fc;
  color: #fff;
  padding: 5px 20px;
  border-radius: 7px;
  cursor: pointer;
}
.right_under {
  background: #f6f5f8;
  padding: 20px;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 13px;
}
.right_under>div{overflow: hidden;white-space: nowrap; text-overflow: ellipsis; overflow: hidden;}
.circle_state_pass {
  background: #497AF2  !important;
}
.lock{background: url('../../../assets/images/lock.png') no-repeat center;background-size: cover;width: 22px;height: 22px;position:absolute;right: 20px;}
.description{white-space:nowrap; overflow:hidden; text-overflow:ellipsis}
.buttonx{width: 100px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;line-height: 28px;text-align: center;cursor: pointer;}
</style>


// WEBPACK FOOTER //
// ./src/page/train/newservice/Scene.vue